export default {
  saveToken (token) {
    return localStorage.setItem('vms_token', token);
  },

  removeToken () {
    return localStorage.removeItem('vms_token');
  },

  checkIsAuthenticated: function () {
    let tokenDataStr = localStorage.getItem('vms_token');
    return Promise.resolve(tokenDataStr);
  },

  getToken () {
    let tokenStr = localStorage.getItem('vms_token');
    return tokenStr || '';
  },
  
  getCredentials () {
    let tokenStr = localStorage.getItem('credentials');
    return tokenStr || null;
  },

  get (key) {
    return localStorage.getItem(key);
  },

  set (key, value) {
    return localStorage.setItem(key, value);
  },

  remove (key) {
    return localStorage.removeItem(key);
  }
};



// WEBPACK FOOTER //
// ./src/utils/authen.js